import { IRemoveByIdsEntity } from '../../thunk/favorites';
import { IApplicationState } from '../../types/redux';

interface IByTypes {
  [key: string]: IRemoveByIdsEntity;
}

export const selectIdsForRemove = (entityId?: number) => (state: IApplicationState) => {
  const byTypes: IByTypes = {};
  if (entityId) {
    const entity = state.results.favoriteEntities.filter(item => item.entityId === entityId);
    if (entity.length) {
      return [
        {
          entityIds: [entityId],
          entityType: entity[0].entityType,
        },
      ];
    }

    return [];
  }

  // oxlint-disable-next-line guard-for-in
  for (const key in state.selected) {
    const selectedEntity = state.selected[key];
    if (!byTypes[selectedEntity.entityType]) {
      byTypes[selectedEntity.entityType] = {
        entityIds: [],
        entityType: selectedEntity.entityType,
      };
    }

    byTypes[selectedEntity.entityType].entityIds.push(selectedEntity.entityId);
  }

  return Object.values(byTypes);
};
